function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.assign.js";
import React from 'react';
import { Link } from 'react-router-dom';
import { AppLink } from '@finect/tabular-core/AppLink';
import { Inner } from '@finect/tabular-core/Inner';
import { FinectLogo } from '../FinectLogo';
import { SubscriptionCTA } from '../SubscriptionCTA';
import { PageFooter, FinectLogoContainer, MainFooterContainer, FooterContent, FooterRightContent, LegalContent, SocialContent, Copyright } from './partials';
import { legal, investments, personalFinances, pills, socials } from './data';
var getLinks = function getLinks(entries) {
  return entries.map(function (entry, index) {
    var href = entry.path;
    var linkProps = entry.type === 'client' ? {
      to: href,
      as: Link
    } : {
      href: href
    };
    entry.rel && (linkProps.rel = entry.rel);
    return entry.show && React.createElement("li", {
      key: index
    }, React.createElement(AppLink, _extends({
      title: entry.text
    }, linkProps, {
      "data-fi-event": "footer-sections"
    }), entry.text));
  });
};
export var Footer = function Footer(_ref) {
  var user = _ref.user,
    _ref$withConversation = _ref.withConversations,
    withConversations = _ref$withConversation === void 0 ? false : _ref$withConversation,
    _ref$newsletterAction = _ref.newsletterAction,
    newsletterAction = _ref$newsletterAction === void 0 ? null : _ref$newsletterAction;
  var isLoggedIn = user && user.hasOwnProperty('isLoggedIn') && user.isLoggedIn;
  return React.createElement(PageFooter, {
    withConversations: withConversations && isLoggedIn
  }, React.createElement(Inner, null, React.createElement(FinectLogoContainer, null, React.createElement(FinectLogo, {
    size: "150px",
    color: "#fff"
  })), React.createElement(MainFooterContainer, null, React.createElement(FooterRightContent, null, React.createElement(SocialContent, null, socials.map(function (social) {
    return React.createElement("a", {
      href: social.link,
      title: social.name,
      key: social.name
    }, social.icon);
  })), newsletterAction && React.createElement(SubscriptionCTA, {
    user: user,
    newsletterAction: newsletterAction,
    title: "Suscr\xEDbete a nuestra Newsletter",
    withText: false,
    withPadding: false,
    withMargin: false,
    backgroundColor: "terciaryDD",
    buttonColor: "terciaryLL",
    buttonBorderColor: "terciaryLL",
    buttonBackgroundColor: "terciaryDD",
    buttonHover: true,
    small: true
  })), React.createElement(FooterContent, null, React.createElement("div", null, React.createElement("div", null, React.createElement("h4", null, React.createElement(AppLink, {
    href: "/sobre-finect",
    "data-fi-event": "footer-sections"
  }, "Sobre nosotros"))), React.createElement("div", null, React.createElement("h4", null, React.createElement(AppLink, {
    href: "/2024",
    "data-fi-event": "footer-sections"
  }, "Finect en 2024"))), React.createElement("div", null, React.createElement("h4", null, React.createElement("a", {
    "data-fi-event": "footer-sections",
    href: "mailto:finect@finect.com"
  }, "Contacta")))), React.createElement("div", null, React.createElement("div", null, React.createElement("h4", null, React.createElement(AppLink, {
    href: "/usuario/maitelpz/articulos/mejores-inversiones-como-donde-invertir",
    "data-fi-event": "footer-sections"
  }, "Mejores inversiones")), React.createElement("ul", null, getLinks(investments))), React.createElement("div", null, React.createElement("h4", null, React.createElement(AppLink, {
    href: "/finanzas-personales",
    "data-fi-event": "footer-sections"
  }, "Finanzas personales")), React.createElement("ul", null, getLinks(personalFinances))), React.createElement("div", null, React.createElement("h4", null, React.createElement(AppLink, {
    href: "/pildoras",
    "data-fi-event": "footer-sections"
  }, "Calculadoras financieras")), React.createElement("ul", null, getLinks(pills)))))), React.createElement(LegalContent, {
    isLoggedIn: isLoggedIn,
    withConversations: withConversations && isLoggedIn
  }, React.createElement(Copyright, null, "Copyright \xA9 ", new Date().getFullYear(), " Finect"), React.createElement("div", null, React.createElement("ul", null, getLinks(legal))))));
};